module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image19.68deb561.webp";